import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Code, Database, Smartphone, Award } from 'lucide-react';
import { personalInfo } from '../mock';

const About = () => {
  const highlights = [
    {
      icon: Code,
      title: 'Web Development',
      description: 'Expert in building responsive web applications with React and modern JavaScript'
    },
    {
      icon: Smartphone,
      title: 'Mobile Development',
      description: 'Creating native iOS & Android apps with React Native'
    },
    {
      icon: Database,
      title: 'Backend Development',
      description: 'Scalable server-side solutions with Node.js and MongoDB'
    },
    {
      icon: Award,
      title: 'Best Practices',
      description: 'Following industry standards and clean code principles'
    }
  ];

  return (
    <>
      <Helmet>
        {/* Schema markup for About section */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "mainEntity": {
              "@type": "Person",
              "name": "Gokul Krishnan Koyattassery",
              "alternateName": "CodingSeagull",
              "description": personalInfo.bio,
              "jobTitle": "Full Stack Developer",
              "knowsAbout": [
                "Web Development",
                "Mobile Development", 
                "React",
                "React Native",
                "Node.js",
                "MongoDB",
                "Backend Development"
              ]
            }
          })}
        </script>
      </Helmet>

      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            {/* SEO H1 - Hidden but crawlable */}
            <h1 className="sr-only">
              About Gokul Krishnan Koyattassery (CodingSeagull) -Full Stack Developer specializing in Web Development and Mobile App Development
            </h1>
            
            {/* Visual heading */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-50 rounded-full mb-6">
              <span className="w-2 h-2 bg-cyan-600 rounded-full animate-pulse"></span>
              <span className="text-sm font-medium text-cyan-700">
                Full Stack Developer
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3 animate-fade-in">
  About <span className="text-cyan-600">Me</span>
</h2>
            
            <p className="text-xl text-gray-700 font-medium mb-1">
              Gokul Krishnan Koyattassery
            </p>
            
            <p className="text-base text-gray-500">
              Also known as <span className="font-semibold text-gray-700">CodingSeagull</span>
            </p>
            
            <div className="w-20 h-1 bg-cyan-600 mx-auto mt-6"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                {personalInfo.bio}
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With a Master's degree in Computer Applications and years of hands-on experience,
                I've successfully delivered numerous <strong> web development</strong> and{' '}
                <strong>mobile app development projects</strong> ranging from complex enterprise systems
                to elegant mobile applications based on the requirements.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                As a <strong>full stack developer</strong>, I specialize in{' '}
                <strong>React, React Native, Next.js, Node.js, and Python</strong>. When I'm not coding, 
                I enjoy contributing to open-source projects, writing technical blogs, and staying 
                updated with the latest technologies in the ever-evolving world of software development.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {highlights.map((item, index) => {
                const Icon = item.icon;
                return (
                  <article
                    key={index}
                    className="p-6 bg-gray-50 rounded-lg hover:shadow-lg transition-all hover:-translate-y-1"
                  >
                    <Icon className="text-cyan-600 mb-4" size={32} aria-hidden="true" />
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm">{item.description}</p>
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;